/* eslint-disable */
/* prettier-ignore */
import * as utils from '../utils'

export default {
  prefix: 'cus',
  iconName: 'multimodal',
  icon: [
    480, // width
    480, // height
    [],
    null,
    `
      M376,288.001h-12.688l-45.656-45.656c-1.5-1.5-3.534-2.344-5.656-2.344H8c-4.418,0-8,3.582-8,8v144c0,4.418,3.582,8,8,8
			h24.208c-5.294,6.883-8.179,15.316-8.208,24c0,22.091,17.909,40,40,40s40-17.909,40-40c-0.029-8.684-2.914-17.117-8.208-24h32.416
			c-5.294,6.883-8.179,15.316-8.208,24c0,22.091,17.909,40,40,40s40-17.909,40-40c-0.029-8.684-2.914-17.117-8.208-24h96.416
			c-5.294,6.883-8.179,15.316-8.208,24c0,22.091,17.909,40,40,40c22.091,0,40-17.909,40-40c-0.029-8.684-2.914-17.117-8.208-24H376
			c4.418,0,8-3.582,8-8v-96C384,291.583,380.418,288.001,376,288.001z M256,256.001h52.688l32,32H256V256.001z M64,448.001
			c-13.255,0-24-10.745-24-24s10.745-24,24-24s24,10.745,24,24S77.255,448.001,64,448.001z M160,448.001c-13.255,0-24-10.745-24-24
			s10.745-24,24-24s24,10.745,24,24S173.255,448.001,160,448.001z M240,384.001H48v-80H32v80H16v-128h224V384.001z M320,448.001
      c-13.255,0-24-10.745-24-24s10.745-24,24-24s24,10.745,24,24S333.255,448.001,320,448.001z M368,384.001H256v-80h112V384.001z
      
      M473.944,144.241c-0.636-0.159-1.288-0.24-1.944-0.24h-16v-56c0-4.418-3.582-8-8-8H312
			c-4.034,0.001-7.436,3.005-7.936,7.008l-7.128,56.992H248c-4.418,0-8,3.582-8,8c0,0.655,0.081,1.308,0.24,1.944l16,64
			c0.892,3.559,4.091,6.056,7.76,6.056h192c3.669,0,6.868-2.497,7.76-6.056l16-64C480.834,149.659,478.23,145.314,473.944,144.241z
       M319.064,96.001H440v48H313.064L319.064,96.001z M449.752,208.001H270.248l-12-48h203.504L449.752,208.001z
       
      M239.592,101.473l-16-48c-1.089-3.268-4.147-5.473-7.592-5.472H52.944L39.2,20.425c-1.362-2.725-4.153-4.441-7.2-4.424H8
			c-4.418,0-8,3.582-8,8v80c0,4.418,3.582,8,8,8h62.24l-14.08,70.4c-0.884,4.329,1.909,8.555,6.238,9.438
			c0.527,0.108,1.064,0.162,1.602,0.162h32c2.611-0.001,5.056-1.277,6.552-3.416l53.616-76.584H232
			c4.418,0.001,8.001-3.58,8.002-7.998C240.002,103.143,239.864,102.289,239.592,101.473z M16,32.001h11.056l8,16H16V32.001z
       M91.832,176.001H73.76l12.8-64h50.08L91.832,176.001z M192,96.001v-16h-16v16H16v-32h194.232l10.672,32H192z
       
      ${utils.rect(32, 272, 16, 16)}
      ${utils.rect(336, 112, 32, 16)}
      ${utils.rect(320, 320, 32, 16)}
      
      z
    ` // svg path data
  ]
}



// WEBPACK FOOTER //
// ./src/components/icon/custom-icons/custom-icons/multimodal.js